import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('[widget-type="swiper"]').forEach((swiperWidget) => {
        // const [Swiper, _] = await Promise.all([import('swiper/bundle').then(x => x.default), import('swiper/css/bundle')]) // Experimenting with async import
        const swiperElement = swiperWidget.querySelector(".mySwiper")
        const nextEl = swiperWidget.querySelector(".swiper-button-next-unique")
        const prevEl = swiperWidget.querySelector(".swiper-button-prev-unique")
        const pagination = swiperWidget.querySelector(".swiper-pagination")

        /**
         * @type {import('swiper').Swiper}
         */
        var swiper = new Swiper(swiperElement, {
            slidesPerView: 3,
            spaceBetween: 28,
            pagination: {
                el: pagination,
                clickable: true,
            },
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },
        })
    
        swiper.on("slideChange", () => {
            const targetNavNext = swiperWidget.querySelector(".swiper-nav-next-unique");
            const targetNavPrev = swiperWidget.querySelector(".swiper-nav-prev-unique");
            if (swiper.isEnd) {
                targetNavNext.classList.remove("swiper-button-next-unique-icon");
                targetNavNext.classList.add("swiper-button-next-unique-icon-inactive");
            } else {
                targetNavNext.classList.remove("swiper-button-next-unique-icon-inactive");
                targetNavNext.classList.add("swiper-button-next-unique-icon");
            }
            if (!swiper.isBeginning) {
                targetNavPrev.classList.remove("swiper-button-prev-unique-icon-inactive");
                targetNavPrev.classList.add("swiper-button-prev-unique-icon");
            } else {
                targetNavPrev.classList.remove("swiper-button-prev-unique-icon");
                targetNavPrev.classList.add("swiper-button-prev-unique-icon-inactive");
            }
        })
    })
})